const UserStatus = Object.freeze({
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
  ACCOUNT: 'ACCOUNT'
})
export default UserStatus
// RESERVE BELOW
